import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from './stationSearchActions';
import './Suggested.scss';

class Suggested extends Component {
  componentDidMount() {
    this.props.actions.loadSuggested();
    this.props.actions.loadRecent();
  }

  render() {
    var f = this.props.selectResult;

    return (
      <div className="suggested">
        {this.renderPopular(f)}
        {this.renderRecent(f)}
      </div>
    );
  }

  renderPopular(onSelect) {
    if (this.props.showPopular && this.props.popular.length) {
      return <Popular items={this.props.popular} onSelect={onSelect} />
    }
  }

  renderRecent(onSelect) {
    if (this.props.recent.length) {
      return <Recent items={this.props.recent} onSelect={onSelect}/>
    }
  }
}

class Popular extends Component {
  render() {
    var items = _.map(this.props.items, x => this.renderItem(x));

    return (
      <div className="popular">
        <div className="title">POPULAR DESTINATIONS</div>
        <div className="items">
          {items}
        </div>
      </div>
    )
  }

  renderItem(item) {
    return (
      <div className="item" key={item.id} onClick={this.onSelect.bind(this, item)}>
        <div className="thumbnail-container">
          <img src={item.thumbnail_url}/>
          <div
            className="skim"
            style={{backgroundColor: `rgba(0,0,0,${item.opacity})`}}>
          </div>
        </div>
        <div className="title">{item.title}</div>
      </div>
    );
  }

  onSelect(item) {
    if (item.station) {
      this.props.onSelect(item.station);
    } else if (item.link_url) {
      window.location.href = item.link_url;
    }
  }
}

class Recent extends Component {
  render() {
    var items = _.map(this.props.items, x => this.renderItem(x))

    return (
      <div className="recent">
        <div className="title">RECENT</div>
        <div className="items">
          {items}
        </div>
      </div>
    );
  }

  renderItem(item) {
    var f = () => {
      this.props.onSelect(item);
    };

    return (
      <div
        className="item"
        key={`${item.result_type}_${item.result_id}`}
        onClick={f}>
        <div className="title">{item.title}</div>
        <div className="subtitle">{item.subtitle} &bull; {item.code} </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    popular: state.stationSearch.suggested.popular,
    recent: state.stationSearch.recent
  }

}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Suggested);
